import {
  Skeleton,
  Typography
} from "antd";
import {
  FC,
  Fragment,
  useEffect,
  useState
} from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

//!STYLES
import { isToday } from "common/enums";
import AppResult from "components/appResults";
import { useSelector } from "react-redux";
import CardReservationsStudent from "screens/student/calendar/components/card";
import { useGetHistoriqueStudentQuery } from "store/services/teacher/classes.services";
import s from "../assets/calendar.module.css";

const { Text } = Typography;

type Props = {
  student: any,
}

const CalendarOfReservationStudent: FC<Props> = ({ student }) => {

  const { user } = useSelector((state) => state.auth);
  const {
    data: reservations,
    isLoading,
    isError,
    refetch,
  } = useGetHistoriqueStudentQuery(student?._id);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  const [courses, setCourses] = useState<any>([]);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (reservations?.data) {
      const sortedCourses = [...reservations?.data].sort(
        (a: any, b: any) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
      );

      const groupedByDate = sortedCourses.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setCourses(groupedByDate);
    }
  }, [reservations]);

  return (
    <div>
      {isLoading ? (
        <>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </>
      ) : (
        <Fragment>
          <div className={s.calendar}>
            {reservations?.data?.length > 0 ? (
              courses && Object.keys(courses)?.map((date) => {
                return (
                  <>
                    <div key={date} style={{ marginTop: "10px" }}>
                      <div className={s.dateBox}>
                        {new Intl.DateTimeFormat("fr-FR", {
                          weekday: "long",
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }).format(new Date(date))}
                        {isToday(date) && <div className={s.todayBox}>Aujourd’hui</div>}
                        <div className={s.horizontalLine}></div>
                      </div>
                      {!isMobile && courses[date].map((course: any) => (
                        <div key={course.id}>
                          <CardReservationsStudent course={course} isHistorique={false} />
                        </div>
                      ))}

                      {isMobile && <div className={s.cardDisplay} /* className={`${s.cardDisplay} ${courses[date].length === 1 ? s.singleCourse : ""}`} */>
                        {courses[date].map((course: any) => (
                          <div key={course.id}>
                            <CardReservationsStudent course={course} isHistorique={false} />
                          </div>
                        ))}
                      </div>}
                    </div>
                  </>
                );
              })
            ) : (
              <div className={s.emptyClass}>
                <AppResult status={"info"} title={"Aucune séance"}></AppResult>
              </div>
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default CalendarOfReservationStudent;
